











import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import helpers from '@/shared/service/helper'

@Component({
    name: 'ldw-separator'
})

export default class SeparatorComponent extends Vue {
    // properties
    @Prop(String) private readonly refferer: string | undefined
    @Prop(String) private readonly headline: string | undefined
    @Prop(String) private readonly subheadline: string | undefined
    @Prop(String) private readonly type: string | undefined
    @Prop(String) private readonly icon: string | undefined
    @Prop(String) private readonly buttonText: string | undefined
    // data
    // methods
    public findSeparatorComponent(component: string) {
        const anchorComponent: any = this.$parent.$children.find((ref) => Object.keys(ref.$refs)[0] === component)
        helpers.scrollToComponent(anchorComponent.$el)
    }
}
